import React, { createContext, useContext, useEffect, useState } from 'react';

const AlertaContext = createContext()

export const useAlert = () => useContext(AlertaContext)

export const AlertaProvider = ({children}) => {
  const [alerts, setAlerts] = useState([]);

  const addAlert = (message, type = 'info', duration= 5000) => {
    setAlerts([...alerts, { id: Date.now(), message, type, duration }]);
  };

  const removeAlert = (id) => {
    setAlerts(alerts.filter(alert => alert.id !== id));
  };

  useEffect(() => {
    const timers = alerts.map(alert =>
      setTimeout(() => {
        removeAlert(alert.id);
      }, alert.duration)
    );

    return () => {
      timers.forEach(timer => clearTimeout(timer));
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alerts]);

  return (
    <AlertaContext.Provider value={{ alerts, addAlert, removeAlert }}>
      {children}
    </AlertaContext.Provider>
  );
}